import { Link } from 'react-router-dom';
import { useState } from 'react';
import HeroSection from './components/HeroSection';
import WhyChooseUs from './components/WhyChooseUs';
import CoreServices from './components/CoreServices';
import HowWeWork from './components/HowWeWork';
import AboutSection from './components/AboutSection';
import Testimonials from './components/Testimonials';
import ContactSection from './components/ContactSection';
import PartnersSection from './components/PartnersSection';
import FAQSection from './components/FAQSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <WhyChooseUs />
      <CoreServices />
      <HowWeWork />
      <AboutSection />
      <PartnersSection />
      <Testimonials />
      <FAQSection />
      <ContactSection />
    </div>
  );
}
